import React from "react";
import PageTemplate from "../components/PageTemplate";
import ViewHeaderMobile from "../components/viewSpotlight/ViewHeaderMobile";
import MobileSwitcher from "../components/MobileSwitcher";
import ViewBodyDesktop from "../components/viewSpotlight/ViewBodyDesktop";
import ViewBodyMobile from "../components/viewSpotlight/ViewBodyMobile";

const ViewSpotlight = () => {

  return (
    <PageTemplate
      title='Spotlight Details'
      mobileHeader={<ViewHeaderMobile />}
      sidebarTitle='View Spotlight'
      sidebarSubtitle='You can see details and analytics from here.'
      centered
    >
      <MobileSwitcher
        mobileComponent={<ViewBodyMobile />}
        desktopComponent={<ViewBodyDesktop />}
      />
    </PageTemplate>
  );
};

export default ViewSpotlight;
